<template>
    <div class="modal fade" id="addUploadServerModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add a New Upload Server</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">

                    <p><strong>Notice:</strong> This will not create an upload server. This only adds an existing server to be used as a destination.</p>

                    <p>Enter the server details to add the server.</p>

                    <div class="form-group row mt-4">
                        <label for="city" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">City</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="city" placeholder="Atlanta" v-model="data.city">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="state" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">State</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="state" placeholder="GA" v-model="data.state">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="country" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Country</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="country" placeholder="USA" v-model="data.country">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="server_id" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Server ID</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="server_id" placeholder="atl-upload"  v-model="data.server_id">
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" v-on:click="addServer" data-dismiss="modal">Add Server</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { EventBus } from '../../../utils/events';
    import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';

    export default {
        data() {
            return {
                data: {
                    city: null,
                    state: null,
                    country: null,
                    server_id: null,
                    locationPoint: null,
                    online: true,
                }
            }
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('admin-upload-server-open-modal', this.open);
            }.bind(this));
        },

        destroyed() {
            EventBus.$off('admin-upload-server-open-modal', this.open);
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),
            close() {
                // this.active = false;
            },

            open() {
                // this.active = true;
            },

            addServer() {
                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/admin/servers", this.data, this.getAuthorizationHeader()).then((response) => {
                    _this.servers = response.data
                });
                EventBus.$emit('admin-upload-server-refresh-data');
            }   
        }
        
    }
</script>
